export const AssetAddressTypes = [
  { id: 'multiple', name: 'Multiple' },
  { id: 'permanent', name: 'Permanent' },
];

export const AssetTypes = [
  { id: 'crypto', name: 'Crypto' },
  { id: 'fiat', name: 'Fiat' },
];
